module.exports = __webpack_public_path__ + "static/fipcwhitelambs1-7d611545ce2c22603ee2f458dd6f0481.jpeg";